import { all } from "redux-saga/effects";
import profileSaga from "./profileSaga";
import superSummarySaga from "./superSummarySaga";

export default function* rootSaga() {
    yield all([profileSaga(), superSummarySaga()]);
}
